import React, { useEffect, useRef, useState } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import moment from 'moment';
import GaugeComponent from 'react-gauge-component';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { UserAuth } from '../../auth/Auth';
import { PrivateAxios, url } from '../../../environment/AxiosInstance';
import { isURL } from '../../../environment/Helper';
import TablePerformance from '../performanceReport/TablePerformance';
import { WaringMessage } from '../../../environment/ToastMessage';
import Loader from '../../../loader/Loader';
import PriorityChat from './PriorityChat';
import './PriorityBaseReport.css';




function PriorityBaseReport() {
    const { Logout, User, MDExist, userDetails, AdminExist } = UserAuth();
    const currentDate = new Date();
    const startDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const endDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        "doer_id": "",
        "startDate": startDateInput,
        "endDate": endDateInput
    })


    const [outStand, setOutStand] = useState({})
    const [completeData, setCompleteData] = useState({})
    const [delayData, setDelayData] = useState({})

    const [gaugeValue, setGaugeValue] = useState(0);
    const [targetValue, setTargetValue] = useState(0)

    const GetReportData = (e) => {
        e.preventDefault();
        setLoading(true)
        if (!data.startDate || !data.endDate || !data.doer_id) {
            WaringMessage("Please select all the fields !");
            setLoading(false);
            return;
        }
        const params = {
            startDate: data.startDate,
            endDate: data.endDate,
            id: data.doer_id.id
        }
        PrivateAxios.get('report/priority-report', { params })
            .then((res) => {
                setOutStand(res.data.data?.Total);
                setCompleteData(res.data.data?.CompletedOnTime);
                setDelayData(res.data.data?.Delayed);
                setTargetValue(100 - Math.floor(res.data?.weightedPercentage));  
                setLoading(false);
            }).catch((err) => {
                setLoading(false)
                console.log(err);

                if (err.response?.status == 401) {
                    Logout();
                    setLoading(false);
                }
            })
    }

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });



    useEffect(() => {
        let currentValue = 0;
        const animationStep = 1;
        const interval = setInterval(() => {
            if (currentValue >= targetValue) {
                clearInterval(interval);
            } else {
                currentValue += animationStep;
                setGaugeValue(currentValue);
            }
        }, 20);

        return () => clearInterval(interval);
    }, [targetValue]);



    const getUser = (item) => {
        setData({ ...data, doer_id: item });

    }




    //dark theme select
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    // Check for the theme by looking at the body's class list
    useEffect(() => {
        const checkTheme = () => {
            setIsDarkTheme(document.body.classList.contains("dark-theme"));
        };

        // Initial check
        checkTheme();

        // MutationObserver to detect theme changes on body
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Clean up observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme select end



    //custom range select
    const [selectedRange, setSelectedRange] = useState('3m'); // Default selection
    const [fmsData, setFmsData] = useState({ startDate: null, endDate: null });
    const handleRadioChange = (event) => {
        setSelectedRange(event.target.value);
    };


    return (
        <>
            <div className="p-4 priority-report-container">
                <div className="mb-4 d-flex align-items-center justify-content-betweem">
                    <Link className="text-dark back-btn me-3" to="/reports">
                        <i className="fas fa-long-arrow-alt-left me-1" />Back
                    </Link>
                </div>

                {loading ? <Loader /> : ""}

                <div className="container-fluid px-0">
                    <div className="row">
                        <div className="col-12">
                            <form className='card mb-4 priority-report-filter-card' onSubmit={GetReportData}>
                    <div className="card-header">
                        <h3 className="card-title">Priority Base Report</h3>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='w-100'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                                    <div className='form-group'>
                                        <label className='form-label'>Doer Name <span className='text-exp-red'>*</span></label>
                                        <div className='custom-select-wrap'>
                                            <Select
                                                required
                                                options={MDExist || AdminExist ? User : userDetails.branch_position == "HOD" ? User.filter(item => item.departments_id == userDetails.departments_id && item.branch_id == userDetails.branch_id) : User.filter(item => item.id == userDetails.id)}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}

                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#ddddff',
                                                        primary: '#6161ff',
                                                    },
                                                })}
                                                onChange={(item) => {
                                                    getUser(item);
                                                }

                                                }
                                                styles={{
                                                    menu: (base) => ({
                                                        ...base,
                                                        backgroundColor: isDarkTheme ? "#06162f" : "#ffffff",
                                                        color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isFocused ? (isDarkTheme ? "#112a46" : "#ddddff") : "transparent",
                                                        color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                                    <div className='form-group'>
                                        <label className='form-label'>From <span className='text-exp-red'>*</span></label>
                                        <div className="exp-datepicker-cont">
                                            <span className="cal-icon"><i class="fas fa-calendar-alt" /></span>
                                            <DatePicker
                                                required
                                                selected={data.startDate}
                                                onChange={(item) => setData({ ...data, startDate: new Date(item) })}
                                                dateFormat="dd/MM/YYYY"
                                                placeholderText='Select Date'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                                    <div className='form-group'>
                                        <label className='form-label'>To <span className='text-exp-red'>*</span></label>
                                        <div className="exp-datepicker-cont">
                                            <span className="cal-icon"><i class="fas fa-calendar-alt" /></span>
                                            <DatePicker
                                                required
                                                selected={data.endDate}
                                                onChange={(item) => setData({ ...data, endDate: new Date(item) })}
                                                dateFormat="dd/MM/YYYY"
                                                placeholderText='Select Date'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        <button type="reset" name="reset_button" className="btn btn-exp-light me-2">Reset</button>
                        {/* {data.doer_id.length == 1 || data.doer_id?.length == 0 || !data.doer_id ? */}
                        <button type="submit" name="submit_button" className="btn btn-exp-green" >Generate Report</button>
                        {/* : ""
                        } */}
                    </div>
                </form>
                <div className="row">
                    {/* no data found */}
                    <div className='col-12'>
                        <div className='card mb-0'>
                            <div className='card-header'>
                                {/* {data.doer_id?.length == 0 ? "" : data.doer_id?.length == 1 || data.doer_id?.length == 0 || !data.doer_id ? */}
                                <h5 className='card-title'>{data.doer_id ? `${User.find(item => item.id == data.doer_id?.id)?.name} (${User.find(item => item.id == data.doer_id?.id)?.phone_number}) ${data.startDate ? moment(data.startDate).format('DD-MM-YYYY') : ""} ${data.startDate && data.endDate ? 'to' : ""} ${data.endDate ? moment(data.endDate).format('DD-MM-YYYY') : ""}` : ""}</h5>
                                {/* } */}
                            </div>
                            <div className='card-body'>

                                <div className='priority-report-charts-container'>
                                    <div className='priority-report-chart-item'>
                                        <div className='card graph-card h-100 mb-0'>
                                            <div className='card-body'>
                                                <div id='preview'>
                                                    <div className='overall-performance-wrap text-center'>
                                                        <h5 className='card-title mb-2'>Overall Performance</h5>
                                                        <div className='text-center'>
                                                            <GaugeComponent
                                                                value={gaugeValue}
                                                                type="radial"
                                                                style={{
                                                                    width: '100%',
                                                                    height: 'fit-content',
                                                                    margin: '0 auto',
                                                                    minWidth: '200px',
                                                                    maxWidth: '320px'
                                                                }}
                                                                labels={{
                                                                    tickLabels: {
                                                                        type: "outer",
                                                                        ticks: [
                                                                            { value: 20 },
                                                                            { value: 40 },
                                                                            { value: 60 },
                                                                            { value: 80 },
                                                                            { value: 100 }
                                                                        ]
                                                                    },
                                                                }}
                                                                arc={{
                                                                    colorArray: ['rgb(100, 207, 92)', 'rgb(232, 77, 77)'],
                                                                    subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
                                                                    width: 0.3,
                                                                    padding: 0,
                                                                    cornerRadius: 0,
                                                                }}
                                                                pointer={{
                                                                    elastic: true,
                                                                    animationDelay: 0
                                                                }}
                                                            />
                                                        </div>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <h4 className='mb-0 fs-2 fw-bold'>Negative {gaugeValue}%</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='priority-report-chart-item' id='fms_chart_div_inner'>
                                        <PriorityChat
                                            notComplete={
                                                (outStand?.weightedTotal || 0) -
                                                ((completeData?.weightedCompletedOnTime || 0) + ((delayData?.weightedDelayed || 0)))
                                            }
                                            onTimeComplete={completeData?.weightedCompletedOnTime || 0}
                                            delay={(delayData?.weightedDelayed || 0) / 2}
                                        />
                                    </div>
                                </div>

                                <div className='row'>
                                    {/* <div className="col-12">
                                        <div className="card bg-warning-light mb-0">
                                            <div className="card-body">
                                                <div className="exp-no-data-found text-exp-red">
                                                    <img className="task-img mb-3" src={process.env.PUBLIC_URL + 'assets/images/search-no-record-found.webp'} alt="No task" />
                                                    <h6>No Record Found</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    {data.doer_id?.length > 1 ? (
                                        <div className='col-12'>
                                            <div className="card mb-0">
                                                <div className="card-body">
                                                    <div className='d-flex justify-content-between flex-wrap align-items-center pt-3 px-3'>
                                                        <div className='table-button-group mb-3'>
                                                            {/* <button className='btn table-export-btn' >
                                                            <i className="fas fa-file-csv"></i>
                                                        </button> */}
                                                            {/* <button className='btn table-export-btn'>
                                                            <i className="fas fa-file-pdf"></i>
                                                        </button> */}
                                                            <button className='btn table-export-btn' style={{ borderRadius: "10px 10px 10px 10px" }} onClick={reactToPrintFn}>
                                                                <i className="fas fa-print"></i>
                                                            </button>
                                                        </div>
                                                        <div className='mb-3 bg-light p-2 rounded-10 shadow-sm'>
                                                            <div className='fw-bold'>
                                                                <span className='text-danger'>Very High: 10</span> | <span className='text-warning'>High: 8</span> | <span className='text-primary'>Medium: 5</span> | <span className='text-secondary'>Low: 3 points</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='table-responsive' ref={contentRef}>

                                                        {
                                                            data.doer_id && data.doer_id?.length > 0 ?
                                                                data.doer_id.map((data) => (
                                                                    <>
                                                                        <div className='p-2 bg-light rounded-top-10'>

                                                                            {User && User.map((item) => (
                                                                                item.id == data.id ?
                                                                                    < div className="profile-wrap direct-report-member-box" key={item.id}>
                                                                                        <div className="exp-avtar bg-exp-yellow">
                                                                                            {item.user_photo != null ?
                                                                                                < img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                                                                <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                                                            }
                                                                                        </div>
                                                                                        <div className="ps-2 profile-name-wrap text-truncate">
                                                                                            <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                                                                        </div>
                                                                                    </div> : ""
                                                                            ))
                                                                            }

                                                                            {/* <div className="profile-wrap ">
                                                                                <div className="exp-avtar bg-exp-yellow">
                                                                                    <img
                                                                                        className="prof-img"
                                                                                        src="http://192.168.1.16:5000/api/uploads/1705985537.jpg"
                                                                                        alt="user"
                                                                                    />
                                                                                </div>
                                                                                <div className="ps-2 profile-name-wrap text-truncate">
                                                                                    <h5 className="profile-name text-nowrap text-truncate">Amit Das Gupta</h5>
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                        <TablePerformance startDateInput={startDateInput} endDateInput={endDateInput} setLoading={setLoading} doer_id={data.id} />
                                                                    </>
                                                                )) : ""

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='col-12'>
                                            <div className="card mb-0">
                                                <div className="card-body p-0">
                                                    <div className='d-flex justify-content-between flex-wrap align-items-center pt-3 px-3'>
                                                        <div className='table-button-group mb-3'>
                                                            {/* <button className='btn table-export-btn' >
                                                            <i className="fas fa-file-csv"></i>
                                                        </button> */}
                                                            {/* <button className='btn table-export-btn'>
                                                            <i className="fas fa-file-pdf"></i>
                                                        </button> */}
                                                            <button className='btn table-export-btn' style={{ borderRadius: "10px 10px 10px 10px" }} onClick={reactToPrintFn}>
                                                                <i className="fas fa-print"></i>
                                                            </button>
                                                        </div>
                                                        <div className='mb-3 bg-light p-2 rounded-10 shadow-sm'>
                                                            <div className='fw-bold'>
                                                                <span className='text-danger'>Very High: 10</span> | <span className='text-warning'>High: 8</span> | <span className='text-primary'>Medium: 5</span> | <span className='text-secondary'>Low: 3 points</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='table-responsive' ref={contentRef}>
                                                        <table
                                                            className="table table-bordered"
                                                        >
                                                            <tbody>
                                                                <tr className="odd">
                                                                    <th nowrap="">&nbsp;</th>
                                                                    <th nowrap="" className="text-center bg-error-200">
                                                                        Very High
                                                                    </th>
                                                                    <th nowrap="" className="text-center bg-warning-200">
                                                                        High
                                                                    </th>
                                                                    <th nowrap="" className="text-center bg-primary-200">
                                                                        Medium
                                                                    </th>
                                                                    <th
                                                                        className="text-center bg-secondary-200"
                                                                    >
                                                                        Low
                                                                    </th>
                                                                    <th nowrap="" className="text-center bg-success-200">
                                                                        Score
                                                                    </th>
                                                                </tr>

                                                                <tr>
                                                                    <th>
                                                                        <strong>Outstanding</strong>
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {outStand?.priority1Total ? outStand?.priority1Total : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {outStand?.priority2Total ? outStand?.priority2Total : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {outStand?.priority3Total ? outStand?.priority3Total : 0}
                                                                    </th>
                                                                    <th
                                                                        className="text-center"
                                                                    >
                                                                        {outStand?.priority4Total ? outStand?.priority4Total : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {outStand?.weightedTotal ? outStand?.weightedTotal : 0}
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <strong>Completed</strong>
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {completeData?.priority1CompletedOnTime ? completeData?.priority1CompletedOnTime : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {completeData?.priority2CompletedOnTime ? completeData?.priority2CompletedOnTime : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {completeData?.priority3CompletedOnTime ? completeData?.priority3CompletedOnTime : 0}
                                                                    </th>
                                                                    <th
                                                                        className="text-center"
                                                                    >
                                                                        {completeData?.priority4CompletedOnTime ? completeData?.priority4CompletedOnTime : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {completeData?.weightedCompletedOnTime ? completeData?.weightedCompletedOnTime : 0}
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <strong>Delay Completed</strong>
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {delayData?.priority1Delayed ? delayData?.priority1Delayed : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {delayData?.priority2Delayed ? delayData?.priority2Delayed : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {delayData?.priority3Delayed ? delayData?.priority3Delayed : 0}
                                                                    </th>
                                                                    <th
                                                                        className="text-center"
                                                                    >
                                                                        {delayData?.priority4Delayed ? delayData?.priority4Delayed : 0}
                                                                    </th>
                                                                    <th nowrap="" className="text-center">
                                                                        {delayData?.weightedDelayed ? (delayData?.weightedDelayed / 2) : 0}
                                                                    </th>
                                                                </tr>


                                                            </tbody>
                                                        </table>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default PriorityBaseReport
